export default {
  LIST: 'LIST',
  MAP: 'MAP'
};



// WEBPACK FOOTER //
// ./src/constants/reservationsViewTypes.js